(() => {
  const titles = {
    description: 'DESCRIPCIÓN',
    sizes: 'GUÍA DE TALLAS',
    d3o: 'QUÉ ES D3O®',
    shipping: 'ENVÍOS, CAMBIOS Y DEVOLUCIONES',
    warranty: 'GARANTÍAS'
  };

  function init(root) {
    const drawer = root.querySelector('[data-ul-info-drawer]');
    if (!drawer || drawer.dataset.ulReady === 'true') return;
    drawer.dataset.ulReady = 'true';
    const panel = drawer.querySelector('.ul-info-drawer__panel');
    const body = drawer.querySelector('.ul-info-drawer__body');
    const title = drawer.querySelector('[data-ul-panel-title]');
    const contents = [...drawer.querySelectorAll('[data-ul-panel-content]')];
    let opener = null;
    let activeKey = null;

    const close = ({ restoreFocus = true } = {}) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ul-panel-open');
      root.querySelectorAll('[data-ul-panel-open]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
        button.removeAttribute('data-ul-panel-active');
      });
      activeKey = null;
      if (restoreFocus) opener?.focus();
    };

    const open = async (button) => {
      const key = button.dataset.ulPanelOpen;
      if (!titles[key]) return;
      if (drawer.classList.contains('is-open') && activeKey === key) {
        close({ restoreFocus: false });
        return;
      }

      const cartDrawer = document.querySelector('#cart-drawer');
      if (cartDrawer?.hasAttribute('open') && typeof cartDrawer.close === 'function') {
        await cartDrawer.close();
      }

      opener = button;
      activeKey = key;
      title.textContent = titles[key];
      contents.forEach((content) => { content.hidden = content.dataset.ulPanelContent !== key; });
      root.querySelectorAll('[data-ul-panel-open]').forEach((trigger) => {
        const isActive = trigger.dataset.ulPanelOpen === key;
        trigger.setAttribute('aria-expanded', String(isActive));
        if (isActive) trigger.setAttribute('data-ul-panel-active', 'true');
        else trigger.removeAttribute('data-ul-panel-active');
      });
      document.querySelector('#header-group')?.classList.remove('ul-header-group--hidden');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ul-panel-open');
      panel.scrollTop = 0;
      if (body) body.scrollTop = 0;
      panel.focus();
    };

    root.querySelectorAll('[data-ul-panel-open]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => open(button));
    });
    drawer.querySelectorAll('[data-ul-panel-close]').forEach((button) => button.addEventListener('click', close));
    drawer.querySelector('.ul-info-drawer__header')?.addEventListener('click', (event) => {
      if (event.target.closest('[data-ul-panel-close]')) return;
      close();
    });
    body?.addEventListener('click', (event) => {
      if (event.target.closest('a, button, input, select, textarea, summary, details, label, video, audio, iframe')) return;
      close({ restoreFocus: false });
    });
    drawer.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    document.addEventListener('theme-drawer:open', (event) => {
      if (event.target?.id === 'cart-drawer' && drawer.classList.contains('is-open')) {
        close({ restoreFocus: false });
      }
    });
    document.addEventListener('pointerdown', (event) => {
      if (!drawer.classList.contains('is-open')) return;
      if (panel.contains(event.target)) return;
      close({ restoreFocus: false });
    });
  }

  const initAll = (scope = document) => scope.querySelectorAll('[data-ul-product]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
